import { render, staticRenderFns } from "./MakeRequestJoinForm.vue?vue&type=template&id=77c1fa6f&scoped=true&"
import script from "./MakeRequestJoinForm.vue?vue&type=script&lang=js&"
export * from "./MakeRequestJoinForm.vue?vue&type=script&lang=js&"
import style0 from "./MakeRequestJoinForm.vue?vue&type=style&index=0&id=77c1fa6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c1fa6f",
  null
  
)

export default component.exports